import {useMutation} from '@tanstack/react-query';
import {getLocalStorage} from '@/Utils/CommonUtils';
import ChessRestClient from '@/Api/ChessRestClient';

type RescheduleSessionVars = {
  call_id: number;
  start_time: string;
  comment?: string;
};

export default function useRescheduleSessionApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  const mutation = useMutation<any, Error, RescheduleSessionVars>(
    async (variables: RescheduleSessionVars) => {
      const token = await getLocalStorage('access_token');

      // Determine the endpoint based on cancellation type
      const endpoint = 'subscription/v1/sessions/reschedule-session/';

      const payload = {
        session_id: variables.call_id,
        start_time: variables.start_time,
        comment: variables.comment,
      };

      const response = await ChessRestClient.post(endpoint, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      });

      return response;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) {
          handleOnSuccess(data.data);
        }
      },
      onError: error => {
        if (handleOnError) {
          handleOnError(error?.response?.data);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}
